// removed by extract-text-webpack-plugin
module.exports = {"ZeroResultWrapper":"ZeroResult-module__ZeroResultWrapper__2Agas","ZeroResult":"ZeroResult-module__ZeroResult__JxmVM","ZeroResultContent":"ZeroResult-module__ZeroResultContent__2yxcs","Header":"ZeroResult-module__Header__3kj5w","SubTitle":"ZeroResult-module__SubTitle__27PwP","SecondSubTitle":"ZeroResult-module__SecondSubTitle__3xbcC","Img":"ZeroResult-module__Img__dYh_W"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ZeroResult/ZeroResult.module.css
// module id = 1799
// module chunks = 31